import { render, staticRenderFns } from "./basicinputform.vue?vue&type=template&id=41f6f524"
import script from "./basicinputform.vue?vue&type=script&lang=js"
export * from "./basicinputform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports